// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"0066ae5b","230":"afc6f3d5","343":"9c410ecb","351":"c9e22bc4","652":"d65d696e","960":"4ab002b3"}[chunkId] + ".chunk.js";
};